<!-- API/V2 Version -->
<ng-container *ngIf="this.code == '423'">
    <div class="card">
        <div class="header">
            <h2 mat-dialog-title>{{"SESSION.NEW.HEADER" | translate }}</h2>
        </div>
        <mat-dialog-content>
            <div class="content">
                <div class="text">
                    <h3 [innerHTML]="'SESSION.NEW.TEXT_INSTR' | translate: {value: userName}"></h3> 
                </div>
                <mat-dialog-actions class="action">
                    <button mat-raised-button color="primary" 
                        (click)="retryConnection()" 
                        class="continueButton"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'SESSION.NEW.CON_TOOLTIP' | translate}}"
                        matTooltipPosition="below"
                        >
                        <mat-icon>autorenew</mat-icon>
                        {{"SESSION.NEW.BTN_CON" | translate}}
                    </button>
                    <button mat-raised-button color="warn"
                        (click)="cancelAttempt()" 
                        class="terminateButton"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'SESSION.NEW.CANCEL_TOOLTIP' | translate}}"
                        matTooltipPosition="below"
                        >
                        <mat-icon>close</mat-icon>
                        {{"SESSION.NEW.BTN_CANCEL" | translate}}
                    </button>
                </mat-dialog-actions>
            </div>  
        </mat-dialog-content>
    </div>
</ng-container>

<ng-container *ngIf="this.code == '428'">
    <div class="card">
        <div class="header">
            <h2 mat-dialog-title>{{"SESSION.KICKED.HEADER" | translate }}</h2>
        </div>
        <mat-dialog-content>
            <div class="content">
                <div class="text">
                    <h3 [innerHTML]="'SESSION.KICKED.TEXT' | translate"></h3> 
                </div>
                <mat-dialog-actions class="action">
                    <button mat-raised-button color="warn"
                        (click)="cancelAttempt()" 
                        class="terminateButton"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'SESSION.KICKED.CLOSE_TOOLTIP' | translate}}"
                        matTooltipPosition="below"
                        >
                        <mat-icon>close</mat-icon>
                        {{"SESSION.KICKED.BTN_CLOSE" | translate}}
                    </button>
                </mat-dialog-actions>
            </div>  
        </mat-dialog-content>
    </div>
</ng-container>

<ng-container *ngIf="this.code == '0'">
    <div class="card">
        <div class="header">
            <h2 mat-dialog-title>{{"SESSION.ERROR.HEADER" | translate }}</h2>
        </div>
        <mat-dialog-content>
            <div class="content">
                <div class="text">
                    <h3 [innerHTML]="'SESSION.ERROR.TEXT' | translate"></h3> 
                </div>
                <mat-dialog-actions class="action">
                    <button mat-raised-button color="warn"
                        (click)="closeError()"
                        class="terminateButton"
                        #tooltip="matTooltip"
                        matTooltip="{{ 'SESSION.KICKED.CLOSE_TOOLTIP' | translate}}"
                        matTooltipPosition="below"
                        >
                        <mat-icon>close</mat-icon>
                        {{"SESSION.KICKED.BTN_CLOSE" | translate}}
                    </button>
                </mat-dialog-actions>
            </div>  
        </mat-dialog-content>
    </div>
</ng-container>
